import { Component, OnInit,Inject, Injectable } from '@angular/core';
import { UserService } from '../services/user.service';
import { ActivatedRoute,Router } from '@angular/router';
import { PositionService} from '../services/position.service';
import { Message,SelectItem} from 'primeng/primeng';
import { GeofenceService} from '../services/geofence.service';
import  *  as $ from 'jquery';
import { CommandService} from '../services/command.service';
import { SharingService} from '../services/sharing.service';
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-monitoring',
  templateUrl: './monitoring.component.html',
  styleUrls: ['./monitoring.component.css']
})
export class MonitoringComponent implements OnInit {
  blockedDocument: boolean = false;
  options: any;
  overlays: any[];
  map: google.maps.Map;
  firstTime:boolean = true;
  position: any;
  msgs: Message[] = [];
  labels :any[];
  //idDevice: String;
  timerId:any;
  positions: any [];
  markers:google.maps.Marker[]=[];
  polyLines:google.maps.Polyline[]=[];
  showAlarm:boolean = true;
  command :any={};
  displaySendCommand:Boolean = false;
  //idUser:String;
  types: SelectItem[];
  showGeocercas: boolean = false;
  parameters:any={};
  validity:boolean=true;

  constructor(private titleService:Title,private userService:UserService,private activatedRoute:ActivatedRoute,private positionService:PositionService,
    private geofenceService:GeofenceService,private commandService:CommandService, private sharingService:SharingService
  ) { }

  ngOnInit() {
    this.types = [
      {label: 'Desbloqueo de Motor', value: 'UNLOCKED'},
      {label: 'Bloqueo de Motor', value: 'LOCKED'},
      {label: 'Actualizar Posición', value: 'POSITION'}
    ];
    this.activatedRoute.queryParams.subscribe(params => {
      if(params['token']){
        this.parameters = JSON.parse(atob(params['token']));
        if(this.parameters.startDate && this.parameters.endDate){
          this.checkValidity();
        }

      }
    });

    this.options = {
      zoom: 14
    };
  }

  checkValidity(){
    if(this.parameters.startDate){
      this.sharingService.validate(this.parameters).subscribe(response => {
        if(response.status == 'OK'){
          this.validity = true;
        }else{
          this.validity = false;
        }
      }, error =>{
        console.error(error);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
      });
    }
  }

  load(idDevice:String){
    this.positionService.getLastPosition(idDevice).then(data => {
      let response: any = data
      if(response.status == "OK"){
        if(this.firstTime){
          if(response.position){
            this.titleService.setTitle("Seguimiento - "+response.position.nameDevice);
            this.map.setCenter(new google.maps.LatLng(response.position.latitude, response.position.longitude));
            this.firstTime = false;
          }
          this.refreshLastPosition();
          this.timerId = setInterval(() => {
            this.refreshLastPosition();
          }, 10000);
        }

      }
    }).catch(err =>{
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
    });
  }

  setMap(event) {
    this.map = event.map;
      this.load(this.parameters.idDevice);
      this.drawGeofences(this.parameters.idDevice);
  }

  drawGeofences(idDevice:String){
    this.removeGeofences();
    if(this.showGeocercas){
      this.geofenceService.findByDevice(idDevice).then(data => {
        let response: any = data;
        response.geofences.forEach(geofence => {
          if(geofence.type == "C"){
            let latlng = new google.maps.LatLng(geofence.circle.centerLatitude,geofence.circle.centerLongitude);

            let circle = new google.maps.Circle({
              center: latlng,
              fillColor: '#1976D2',
              fillOpacity: 0.35,
              strokeWeight: 1,
              radius: geofence.circle.radius});
              this.overlays.push(circle);
              let mapLabel = new MapLabel({
                text: geofence.name,
                position: latlng,
                map: this.map,
                fontSize: 20,
                align: 'center'
              });
              this.labels.push(mapLabel);
            }else if(geofence.type == "L"){
              let line = new google.maps.Polyline({
                geodesic: true,
                strokeColor: '#1976D2',
                strokeOpacity: 0.35,
                strokeWeight: geofence.line.distance
              });
              let latlng = null;
              geofence.line.coordinates.forEach(item => {
                latlng = new google.maps.LatLng(item.latitude, item.longitude);
                line.getPath().push(latlng);
              });
              this.overlays.push(line);
              let mapLabel = new MapLabel({
                text: "   "+geofence.name,
                position: latlng,
                map: this.map,
                fontSize: 20,
                align: 'left'
              });
              this.labels.push(mapLabel);
            }else if(geofence.type == "P"){
              let polygon = new google.maps.Polygon({
                strokeColor: '#1976D2',
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: '#1976D2',
                fillOpacity: 0.35
              });
              let latlng = null;
              geofence.polygon.coordinates.forEach(item => {
                latlng = new google.maps.LatLng(item.latitude, item.longitude);
                polygon.getPath().push(latlng);
              });
              this.overlays.push(polygon);
              let mapLabel = new MapLabel({
                text: geofence.name,
                position: latlng,
                map: this.map,
                fontSize: 20,
                align: 'center'
              });
              this.labels.push(mapLabel);
            }
          });
        }).catch(err =>{
          console.log(err);
          this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
        });
      }
    }

    removeGeofences(){
      for(let i in this.labels) {
        this.labels[i].setMap(null);
      }
      this.labels = [];
      let newArray = [];
      for(let i in this.overlays) {
        if(this.overlays[i] instanceof google.maps.Polyline && this.overlays[i].strokeColor == "#1976D2"){
          continue;
        }else{
          if(this.overlays[i] instanceof google.maps.Circle  || this.overlays[i] instanceof google.maps.Polygon){
            continue;
          }else{
            newArray.push(this.overlays[i]);
          }
        }
      }
      this.overlays = newArray;
    }

    cleanOverlays(){
      this.markers.forEach(item=>{
        //item.setMap(null);
        item = null;
      });
      this.markers = [];

      this.polyLines.forEach(item=>{
        //item.setMap(null);
        item = null;
      });
      this.polyLines=[];
      this.overlays.forEach(item=>{
        //item.setMap(null);
        item = null;
      });
      this.overlays = [];
    }

    refreshLastPosition(){
      this.checkValidity();
      this.positionService.getLastPositions(this.parameters.idDevice,5).then(data => {
        this.cleanOverlays();
        let response: any = data;
        if(response.status == "OK"){
          this.positions = [];
          if(response.positions){
            response.positions.forEach(item => {
              this.positions.push(item);
            });
          }
          this.positions = this.removeDuplicates(this.positions,"idPosition");
          this.drawTravel();
        }else{
          this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
        }
      }).catch(err =>{
        console.log(err);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
      });
      this.load(this.parameters.idDevice);
    }

    removeDuplicates(originalArray, prop) {
      return originalArray.filter((obj, pos, arr) => {
        return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
      });
    }

    drawTravel(){
      let recorrido = new google.maps.Polyline({
        geodesic: true,
        strokeColor: '#FF0000',
        strokeOpacity: 1.0,
        strokeWeight: 3
      });

      let positionOld : any = null;
      this.positions.forEach(item => {
        let latLng = new google.maps.LatLng(item.latitude, item.longitude);
        recorrido.getPath().push(latLng);
        if(positionOld!=null){
          let distance = this.getDistanceInMeters(item,positionOld)
          if(distance > 200){
            this.addMarkerRecorrido(item);
          }
        }
        positionOld = item;
      });
      this.overlays.push(recorrido);
      this.position = this.positions[0];
      this.addMarker(this.positions[0]);
      this.polyLines.push(recorrido);
    }

    getDistanceInMeters(positionIni:any,positionFin:any) : number{
      let R = 6371;
      let dLat = (positionFin.latitude-positionIni.latitude) * (Math.PI/180);
      let dLon = (positionFin.longitude-positionIni.longitude) * (Math.PI/180);
      let a = Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(positionIni.latitude * (Math.PI/180)) * Math.cos(positionFin.latitude * (Math.PI/180)) *
      Math.sin(dLon/2) * Math.sin(dLon/2);
      let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
      let d = R * c;
      return d*1000;
    }

    addMarkerRecorrido(position: any){
      let latLng = new google.maps.LatLng(position.latitude, position.longitude);

      let infoWindow = new google.maps.InfoWindow({content: this.getContent(position)});
      //let label = {text: position.nameDevice,color: 'blue',fontSize: "12px",fontWeight: "bold"};
      var icon = {
        path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
        scale:1.3,
        fillColor: 'green',
        strokeColor: 'green',
        strokeWeight: 4,
        rotation:position.course,
        anchor: new google.maps.Point(-0.5, 0.5)
      };

      let marker = new google.maps.Marker({position: latLng,icon:icon});

      google.maps.event.addListener(marker,'click', function() {
        infoWindow.open(this.map, marker);
      });
      google.maps.event.addListener(this.map, 'click', function(){
        infoWindow.close();
      });
      this.overlays.push(marker);

      this.markers.push(marker);

      google.maps.event.addListener(infoWindow, 'domready', function() {
        var iwOuter = $('.gm-style-iw');
        var iwBackground = iwOuter.prev();
        iwBackground.children(':nth-child(2)').css({'display' : 'none'});
        iwBackground.children(':nth-child(4)').css({'display' : 'none'});
        // Moves the infowindow 115px to the right.
        //  iwOuter.parent().parent().css({left: '115px'});
        //  iwBackground.children(':nth-child(1)').attr('style', function(i,s){ return s + 'left: 76px !important;'});
        //    iwBackground.children(':nth-child(3)').attr('style', function(i,s){ return s + 'left: 76px !important;'});
        //  iwBackground.children(':nth-child(3)').find('div').children().css({'box-shadow': 'rgba(72, 181, 233, 0.6) 0px 1px 6px', 'z-index' : '1'});

        var iwCloseBtn = iwOuter.next();
        //iwCloseBtn.css({opacity: '1', right: '30px', top: '20px', 'border-radius': '13px', 'box-shadow': '0 0 5px #3990B9'});
        iwCloseBtn.css({'display' : 'none'});
        iwCloseBtn.mouseout(function(){
          $(this).css({opacity: '1'});
        });
      });
    }

    getContent(position: any){
      let alarm = position.extended.find(i => i.key == "alarm");

      let content = '<div id="iw-container">' +
      '<div class="iw-title" style="text-align:center;">'+position.nameDevice+'</div>' +
      '<div class="iw-content">' +
      '<div>'+
      '<label style="font-weight: bold;">ID: </label><label>'+position.idDevice+'</label>' +
      '</div>'+
      '<div>'+
      '<label style="font-weight: bold;">Fecha/Hora: </label><label>'+position.deviceTime+'</label>' +
      '</div>';

      if(position.speed!=null){
        content +='<div><label style="font-weight: bold;">Velocidad: </label><label>'+position.speed.toFixed(2)+'</label></div>';
      }

      if(alarm != undefined){
        content += alarm.value != undefined && alarm.value != '' ? '<label style="font-weight: bold; color: red;">Alarma: </label><label style="color: red;">'+alarm.value+'</label>':'';
      }
      content += '</div></div>';
      return content;
    }

    addMarker(position: any){
      if(position==null){
        return;
      }
      let latLng = new google.maps.LatLng(position.latitude, position.longitude);

      let infoWindow = new google.maps.InfoWindow({content: this.getContent(position),maxWidth: 200});

      let color = "";
      let url="";
      if(this.verifyLastConnection(position.deviceTime)){
        url ="assets/layout/images/markers/cars/car"+position.iconDevice+"r.png";
        color = "red";
      }else{
        url ="assets/layout/images/markers/cars/car"+position.iconDevice+".png";
        color = "blue";
      }
      let label = {text: position.nameDevice,color: color,fontSize: "12px",fontWeight: "bold"};
      let icon = {
        url: url,
        scaledSize: new google.maps.Size(45, 45), // scaled size
        origin: new google.maps.Point(0,0), // origin
        anchor: new google.maps.Point(22.5, 38), // anchor,
        labelOrigin: new google.maps.Point(position.nameDevice.length<8?position.nameDevice.length*4:position.nameDevice.length*2,0)
      };

      let marker = new google.maps.Marker({position: latLng,label:label ,icon:icon,zIndex: 10});
      marker.addListener('click', () => {
        infoWindow.open(this.map, marker);
      });

      google.maps.event.addListener(this.map, 'click', function(){
        infoWindow.close();
      });

      this.overlays.push(marker);

      this.markers.push(marker);

      google.maps.event.addListener(infoWindow, 'domready', function() {
        var iwOuter = $('.gm-style-iw');
        var iwBackground = iwOuter.prev();
        iwBackground.children(':nth-child(2)').css({'display' : 'none'});
        iwBackground.children(':nth-child(4)').css({'display' : 'none'});
        // Moves the infowindow 115px to the right.
        //iwOuter.parent().parent().css({left: '115px'});
        //iwBackground.children(':nth-child(1)').attr('style', function(i,s){ return s + 'left: 76px !important;'});
        //iwBackground.children(':nth-child(3)').attr('style', function(i,s){ return s + 'left: 76px !important;'});
        //iwBackground.children(':nth-child(3)').find('div').children().css({'box-shadow': 'rgba(72, 181, 233, 0.6) 0px 1px 6px', 'z-index' : '1'});

        var iwCloseBtn = iwOuter.next();
        //iwCloseBtn.css({opacity: '1', right: '78px', top: '20px', 'border-radius': '13px', 'box-shadow': '0 0 5px #3990B9'});
        //iwCloseBtn.css({opacity: '1', right: '30px', top: '20px', 'border-radius': '13px', 'box-shadow': '0 0 5px #3990B9'});
        iwCloseBtn.css({'display' : 'none'});

        iwCloseBtn.mouseout(function(){
          $(this).css({opacity: '1'});
        });
      });

      let alarm = position.extended.find(i => i.key == "alarm");
      if(this.showAlarm && alarm != undefined && alarm.value != undefined && alarm.value != ''){
        infoWindow.open(this.map, marker);
        this.showAlarm = false;
        setTimeout(()=> { // map will need some time to load
          this.map.setCenter(new google.maps.LatLng(position.latitude, position.longitude));
        }, 1000);
        setTimeout(()=> { // map will need some time to load
          infoWindow.close();
        }, 30000);
      }
    }

    verifyLastConnection(fechaHora: String): boolean{
      if(fechaHora==null){
        return false;
      }
      let fechaHoraArray = fechaHora.split(" ");
      let fechaArray = fechaHoraArray[0].split("/");
      let horaArray = fechaHoraArray[1].split(":");

      let fechaHoraUltimaConexion = new Date();
      fechaHoraUltimaConexion.setFullYear(+fechaArray[2],+fechaArray[1]-1,+fechaArray[0]);
      fechaHoraUltimaConexion.setHours(+horaArray[0],+horaArray[1],+horaArray[2]);
      let fechaHoraActual = new Date();
      return this.diferenciaEntreFechasEnMinutos(fechaHoraUltimaConexion,fechaHoraActual) > 30;
    }

    diferenciaEntreFechasEnMinutos(a:Date, b:Date):number{
      return Math.floor((b.getTime() - a.getTime()) / (1000 * 60));
    }

    hide(){
      this.displaySendCommand=false;
    }

    showSendCommand(device:any){
      this.command = {idUser:this.parameters.idUser, idDevice:this.position.idDevice,nameDevice:this.position.nameDevice,channel:"GPRS",phone:this.parameters.phone};
      this.displaySendCommand=true;
    }
    sendCommand(){
      this.blockedDocument = true;
      this.commandService.create(this.command).then(data =>{
        let response: any = data;
        if(response.status == 'OK'){
          this.msgs = [{severity:'info', summary:'INFO', detail:'Envío de comando realizado satisfactoriamente'}];
        }else{
          this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
        }
        this.blockedDocument = false;
        this.hide();
      }).catch(err =>{
        this.msgs = [{severity:'error', summary:'ERROR', detail:err}];
        this.blockedDocument = false;
      });
    }
  }



// WEBPACK FOOTER //
// ./src/app/monitoring/monitoring.component.ts